import { service } from '@ember/service';
import { Ability } from 'ember-can';
import type AbilitiesService from 'ember-can/services/abilities';
import type FlowModel from 'garaje/models/flow';
import type GlobalFlowModel from 'garaje/models/global-flow';
import type AuthzService from 'garaje/services/authz';
import { Permission } from 'garaje/utils/ui-permissions';

export default class VisitorTypeAbility extends Ability {
  @service declare abilities: AbilitiesService;
  @service declare authz: AuthzService;

  declare model?: GlobalFlowModel | FlowModel;

  get canView(): boolean {
    return this.authz.hasPermissionAtCurrentLocation(Permission.VISITORS_FLOW_INSPECT);
  }

  get canEdit(): boolean {
    if (this.model?.isGlobal) return this.abilities.can('edit global-flow', this.model);

    return this.authz.hasPermissionAtCurrentLocation(Permission.VISITORS_FLOW_UPDATE);
  }
}
